export enum ActionType {
    SET_DISCOUNT="SET_DISCOUNT"
}

interface setDiscount {
    type: ActionType.SET_DISCOUNT,
    payload: number
}

export type Action = setDiscount;